<template>
  <div>
    <div class="fixed top-0 w-full pt-[8px] bg-white">
      <NavBar />
    </div>
    <div>
      <div class="w-[500px] h-auto px-10 top-[75px] mt-[25px] sm:fixed">
        <!-- <a href="#" v-scroll-to="'#class1'">class 1</a> -->
        <!-- expansion panels  -->
        <div class="w-1/2">
          <v-expansion-panels>
            <ExpansionPanelTitle title="Billing Payments" />
            <v-expansion-panel v-for="(item, i) in parent" :key="i">
              <v-expansion-panel-header>
                {{ item.title }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div v-for="(item, j) in item.child" :key="j">
                  <button
                    v-scroll-to="item.scroll_to"
                    class="
                      w-full
                      hover:text-red-900 hover:bg-gray-200
                      p-2
                      flex
                    "
                  >
                    {{ item.title }}
                  </button>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </div>
      <div class="sm:ml-[250px] sm:px-10 mt-[75px] min-w-[750px]">
        <ListOfPaymentFacilities
          class="class1 pt-[25px]"
          :hTitle="'List of Payment Facilities'"
        />
        <RemindersOfPayments class="class2 pt-[25px]" :hTitle="'Reminders of Payments'" />
        <RegistrationFee class="class3 pt-[25px]" :hTitle="'Registration Fee'" />
        <RealPropertyTax class="class4 pt-[25px]" :hTitle="'Real Property Tax'" />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import ExpansionPanelTitle from "../../../components/ExpansionPanelTitle.vue";
import ListOfPaymentFacilities from "./ListOfPaymentFacilities.vue";
import RemindersOfPayments from "./RemindersOfPayments.vue";
import RegistrationFee from "./RegistrationFee.vue";
import RealPropertyTax from "./RealPropertyTax.vue";
import NavBar from "../../../../../common/NavBar-Fixed.vue";

export default {
  components: {
    ListOfPaymentFacilities,
    RemindersOfPayments,
    RegistrationFee,
    RealPropertyTax,
    NavBar,
    ExpansionPanelTitle,
  },
  data() {
    return {
      show: false,
      parent: [
        {
          title: "Payment",
          id: 1,
            child: [
              {
                title: "List of Payment Facilities",
                scroll_to: ".class1",
                id: 2,
              },
              {
                title: "Reminders of Payment",
                scroll_to: ".class2",
                id: 3,
              },
            ],
        },
        {
          title: "Registration Fee / Real Property Tax",
          id: 4,
          child: [
            {
              title: "Registration Fee",
              scroll_to: ".class3",
              id: 5,
            },
            {
              title: "Real Property Tax",
              scroll_to: ".class4",
              id: 6,
            },
          ],
        },
        // {
        //   title: "Submit Proof of Payment",
        //   id: 3,
        // },
      ],
      items: [
        {
          title: "List of Payment Facilities",
          scroll_to: ".class1",
        },
        {
          title: "Reminders of Payment",
          scroll_to: ".class2",
        },
        {
          title: "Registration Fee",
          scroll_to: ".class3",
        },
        {
          title: "Real Property Tax",
          scroll_to: ".class4",
        },
      ],
    };
  },
};
</script>